"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getCustomerName = void 0;
var __1 = require("../../../..");
var getCustomerName = function (customer) {
    if (!customer) {
        return __1.NOT_APPLICABLE;
    }
    var firstName = customer.firstName, lastName = customer.lastName;
    if (firstName && lastName) {
        return "".concat(firstName, " ").concat(lastName);
    }
    if (firstName || lastName) {
        return "".concat(firstName || '', " ").concat(lastName || '').trim();
    }
    return __1.NOT_APPLICABLE;
};
exports.getCustomerName = getCustomerName;
